// Origens (Tabela A - CST)
export const ORIGENS = [
  { value: "0", label: "0 - Nacional" },
  { value: "1", label: "1 - Estrangeira (Importação Direta)" },
  { value: "2", label: "2 - Estrangeira (Adquirida no Mercado Interno)" },
  { value: "3", label: "3 - Nacional com mais de 40% de conteúdo estrangeiro" },
  { value: "4", label: "4 - Nacional (Processos Produtivos Básicos)" },
  { value: "5", label: "5 - Nacional com menos de 40% de conteúdo estrangeiro" },
  { value: "6", label: "6 - Estrangeira (Importação Direta) sem similar nacional" },
  { value: "7", label: "7 - Estrangeira (Adquirida no Mercado Interno) sem similar nacional" },
  { value: "8", label: "8 - Nacional com mais de 70% de conteúdo estrangeiro" },
];

// CFOP para NFC-e (operações internas de venda)
export const CFOP_OPTIONS = [
  { value: "5101", label: "5101 - Venda Produção Própria" },
  { value: "5102", label: "5102 - Venda Mercadoria Adquirida" },
  { value: "5103", label: "5103 - Venda Produção para Encomendante" },
  { value: "5104", label: "5104 - Venda Merc. p/ Industrialização" },
  { value: "5405", label: "5405 - Venda Merc. Subst. Tributária" },
  { value: "5656", label: "5656 - Venda Combustíveis/Lubrificantes" },
  { value: "5933", label: "5933 - Prestação de Serviço Tributado pelo ISSQN" },
];

// CSOSN - Código de Situação da Operação no Simples Nacional
export const CSOSN_OPTIONS = [
  { value: "102", label: "102 - Tributada SN sem permissão de crédito" },
  { value: "103", label: "103 - Isenção de ICMS no SN para faixa de receita" },
  { value: "300", label: "300 - Imune" },
  { value: "400", label: "400 - Não tributada pelo Simples Nacional" },
  { value: "500", label: "500 - ICMS cobrado anteriormente por ST" },
  { value: "900", label: "900 - Outros (tributação pelo SN com permissão de crédito)" },
];

// CST ICMS - Código de Situação Tributária (Lucro Presumido/Real)
export const CST_ICMS_OPTIONS = [
  { value: "00", label: "00 - Tributada integralmente" },
  { value: "10", label: "10 - Tributada e com cobrança de ICMS por ST" },
  { value: "20", label: "20 - Com redução de base de cálculo" },
  { value: "30", label: "30 - Isenta ou não tributada e com cobrança de ICMS por ST" },
  { value: "40", label: "40 - Isenta" },
  { value: "41", label: "41 - Não tributada" },
  { value: "50", label: "50 - Suspensão" },
  { value: "51", label: "51 - Diferimento" },
  { value: "60", label: "60 - ICMS cobrado anteriormente por ST" },
  { value: "70", label: "70 - Com redução de BC e cobrança de ICMS por ST" },
  { value: "90", label: "90 - Outras" },
];

// CST PIS/COFINS
export const CST_PIS_COFINS_OPTIONS = [
  { value: "01", label: "01 - Operação Tributável (BC = Valor da Operação)" },
  { value: "02", label: "02 - Operação Tributável (BC = Valor da Operação - Alíquota Diferenciada)" },
  { value: "04", label: "04 - Operação Tributável Monofásica (Alíquota Zero)" },
  { value: "05", label: "05 - Operação Tributável por Substituição Tributária" },
  { value: "06", label: "06 - Operação Tributável (Alíquota Zero)" },
  { value: "07", label: "07 - Operação Isenta da Contribuição" },
  { value: "08", label: "08 - Operação sem Incidência da Contribuição" },
  { value: "09", label: "09 - Operação com Suspensão da Contribuição" },
  { value: "49", label: "49 - Outras Operações de Saída" },
  { value: "99", label: "99 - Outras Operações" },
];

// Unidades Comerciais
export const UNIDADES_COMERCIAIS = [
  { value: "UN", label: "UN - Unidade" },
  { value: "PC", label: "PC - Peça" },
  { value: "KG", label: "KG - Quilograma" },
  { value: "G", label: "G - Grama" },
  { value: "LT", label: "LT - Litro" },
  { value: "ML", label: "ML - Mililitro" },
  { value: "CX", label: "CX - Caixa" },
  { value: "DZ", label: "DZ - Dúzia" },
  { value: "PT", label: "PT - Pacote" },
  { value: "BD", label: "BD - Balde" },
  { value: "FD", label: "FD - Fardo" },
  { value: "GF", label: "GF - Garrafa" },
  { value: "LT", label: "LT - Lata" },
];

// Regimes Tributários
export const REGIMES_TRIBUTARIOS = [
  { value: "simples_nacional", label: "Simples Nacional" },
  { value: "simples_nacional_excesso", label: "Simples Nacional - Excesso de Sublimite" },
  { value: "lucro_presumido", label: "Lucro Presumido" },
  { value: "lucro_real", label: "Lucro Real" },
];

// Ambientes NFC-e
export const AMBIENTES_NFCE = [
  { value: "homologacao", label: "Homologação (Testes)" },
  { value: "producao", label: "Produção" },
];

// Integradores de API
export const INTEGRADORES = [
  { value: "acbr_monitor", label: "ACBrMonitorPlus (Local)" },
  { value: "focus_nfe", label: "Focus NFe" },
  { value: "nfe_io", label: "NFe.io" },
  { value: "enotas", label: "eNotas" },
  { value: "webmania", label: "Webmania" },
];

// Códigos UF (Estados)
export const CODIGOS_UF: Record<string, string> = {
  AC: "12", AL: "27", AP: "16", AM: "13", BA: "29",
  CE: "23", DF: "53", ES: "32", GO: "52", MA: "21",
  MT: "51", MS: "50", MG: "31", PA: "15", PB: "25",
  PR: "41", PE: "26", PI: "22", RJ: "33", RN: "24",
  RS: "43", RO: "11", RR: "14", SC: "42", SP: "35",
  SE: "28", TO: "17",
};

// Tipos de Pagamento NFC-e - Códigos SEFAZ
export const TIPOS_PAGAMENTO: Record<string, string> = {
  dinheiro: "01",
  cheque: "02",
  cartao_credito: "03",
  cartao_debito: "04",
  credito_loja: "05",
  vale_alimentacao: "10",
  vale_refeicao: "11",
  vale_presente: "12",
  vale_combustivel: "13",
  pix: "17",
  outros: "99",
};

// Tipos de Pagamento Fiscais - Para uso em formulários
export const TIPOS_PAGAMENTO_FISCAIS = [
  { value: "01", label: "01 - Dinheiro" },
  { value: "02", label: "02 - Cheque" },
  { value: "03", label: "03 - Cartão de Crédito" },
  { value: "04", label: "04 - Cartão de Débito" },
  { value: "05", label: "05 - Crédito Loja" },
  { value: "10", label: "10 - Vale Alimentação" },
  { value: "11", label: "11 - Vale Refeição" },
  { value: "12", label: "12 - Vale Presente" },
  { value: "13", label: "13 - Vale Combustível" },
  { value: "17", label: "17 - PIX" },
  { value: "99", label: "99 - Outros" },
];

// Status NFC-e
export const STATUS_NFCE = [
  { value: "pending", label: "Pendente", color: "bg-yellow-500" },
  { value: "authorized", label: "Autorizada", color: "bg-green-500" },
  { value: "cancelled", label: "Cancelada", color: "bg-red-500" },
  { value: "rejected", label: "Rejeitada", color: "bg-red-500" },
  { value: "contingency", label: "Contingência", color: "bg-orange-500" },
];

// NCMs comuns para restaurantes
export const NCM_SUGERIDOS = [
  { value: "21069090", label: "21069090 - Preparações alimentícias diversas" },
  { value: "19059090", label: "19059090 - Produtos de padaria e confeitaria" },
  { value: "22021000", label: "22021000 - Águas minerais e gasosas" },
  { value: "22029000", label: "22029000 - Outras bebidas não alcoólicas" },
  { value: "22030000", label: "22030000 - Cervejas de malte" },
  { value: "22041000", label: "22041000 - Vinhos espumantes" },
  { value: "22042100", label: "22042100 - Vinhos em recipientes até 2L" },
  { value: "22089000", label: "22089000 - Outras bebidas alcoólicas" },
  { value: "20098900", label: "20098900 - Sucos de frutas" },
  { value: "04014000", label: "04014000 - Leite e creme de leite" },
  { value: "09012100", label: "09012100 - Café torrado não descafeinado" },
];
